import React from 'react';
import './SvgComponents.css';

interface TileProps {
  tx: number;
  ty: number;
  texture: string;
  className?: string;
}

const Tile: React.FC<TileProps> = ({ tx, ty, texture, className }) => {
  return (
    <image
      className={className ? `tile ${className}` : "tile"}
      x={tx}
      y={ty}
      width={32}
      height={32}
      href={texture}
    >
      <title>tile texture</title>
    </image>
  );
};

export default Tile;